import { Box, FormControl, FormHelperText, Grid, Typography } from "@mui/material";
import DateInput from "../../../../components/DateInput";
import { CustomFormControl } from "../../../../components/FormControl";
import { isNotNull, validateIntegerOrEmpty } from "../../../../utils/validation";
import { getHyphenedDate, inputValueToIntOrNull } from "../../../../utils/utils";

const formTitleWidth = 150;

/**
 * 送金通知書　帳票印刷設定フォーム
 */
const PaymentNotificationSettingForm = ({printParameterInput}) => {

  const onChangePropValue = (propName) => (value) => {
    printParameterInput.setPropValue(propName, value);
  };

  return (
    <Box>
      <Typography fontSize={20} fontWeight='bold'>送金通知書 帳票印刷設定</Typography>

      <Box mt={2}>
        <Grid container alignItems='center' spacing={2}>
          <Grid item width={formTitleWidth} paddingBottom={3}>
            <Typography>出力対象荷主</Typography>
          </Grid>
          <Grid item xs='auto'>
            <CommodityOwnerCdFormControl
              value={printParameterInput.value.commodityOwnerCdFrom}
              setValue={onChangePropValue('commodityOwnerCdFrom')}
            />
          </Grid>
          <Grid item xs='auto' paddingBottom={3}>
            <Typography>～</Typography>
          </Grid>
          <Grid item xs='auto'>
            <CommodityOwnerCdFormControl
              value={printParameterInput.value.commodityOwnerCdTo}
              setValue={onChangePropValue('commodityOwnerCdTo')}
            />
          </Grid>
        </Grid>
      </Box>
      
      <Box mt={1}>
        <Grid container alignItems='center' spacing={2}>
          <Grid item width={formTitleWidth} paddingBottom={3}>
            <Typography>出力対象年月日</Typography>
          </Grid>
          <Grid item xs='auto'>
            <DateInputFormControl
              value = {printParameterInput.value.recordDateFrom}
              setValue={onChangePropValue('recordDateFrom')}
            />
          </Grid>
          <Grid item xs='auto' paddingBottom={3}>
            <Typography>～</Typography>
          </Grid>
          <Grid item xs='auto'>
            <DateInputFormControl
              value = {printParameterInput.value.recordDateTo}
              setValue={onChangePropValue('recordDateTo')}
            />
          </Grid>
        </Grid>
      </Box>

    </Box>
  );
};

export default PaymentNotificationSettingForm;

/**
 * 送金通知書入力初期値 
 */
export const paymentNotificationDefaultParameter = {
  commodityOwnerCdFrom: '',
  commodityOwnerCdTo: '',
  recordDateFrom: getHyphenedDate(new Date()),
  recordDateTo: getHyphenedDate(new Date()),
}

/**
 * 送金通知書入力値バリデーション
 */
export const validatePaymentNotification = (formValue) => (
  isNotNull(formValue)
  && formValue.commodityOwnerCdFrom != null && validateIntegerOrEmpty(formValue.commodityOwnerCdFrom)
  && formValue.commodityOwnerCdTo != null && validateIntegerOrEmpty(formValue.commodityOwnerCdTo)
  && formValue.recordDateFrom !== ''
  && formValue.recordDateTo !== ''
);

/**
 * 送金通知書フォームの値を返す
 */
export const returnPaymentNotificationParameter = (formValue) => (validatePaymentNotification(formValue) ? {
  commodityOwnerCdFrom: inputValueToIntOrNull(formValue.commodityOwnerCdFrom),
  commodityOwnerCdTo: inputValueToIntOrNull(formValue.commodityOwnerCdTo),
  recordDateFrom: formValue.recordDateFrom,
  recordDateTo: formValue.recordDateTo,
} : null);

/**
 * 荷主フォームコントロール
 */
const CommodityOwnerCdFormControl = ({value, setValue}) => (
  <CustomFormControl
    value={value}
    setValue={setValue}
    error={!validateIntegerOrEmpty(value)}
    inputSx={{width: "45mm"}}
    helperText={!validateIntegerOrEmpty(value) ? '数字で入力してください':''}
    helperTextSx={{height:'5mm'}}
  />
);

/**
 * 月日フォームコントロール
 */
const DateInputFormControl = ({value, setValue}) => (
  <FormControl error={!value}>
    <DateInput
      value={value}
      setValue={setValue}
      sx={{width:"45mm"}}
    />
    <FormHelperText sx={{height: "5mm"}}>
      {!value ? '日付を入力してください' : ''}
    </FormHelperText>
  </FormControl>
);





